/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import * as stage from "./StagesCase";
import { StageMetaData } from "../../types/ProductService/ProductService";
import { stageMetaDataCase } from "./StagesCase";

export {
  STAGE_CREATED,
  STAGE_DATA_COMPLETED,
  STAGE_WAITING_FOR_FEEDBACK,
  STAGE_DATA_COMPLETED_LAWFIRM,
  STAGE_CHECKED,
  STAGE_IN_PROGRESS,
  STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT,
  STAGE_EXTRAJUDICIAL_REACTION_RECEIVED,
  STAGE_ACTION_REQUIRED,
  STAGE_PREPARE_LAWSUIT,
  STAGE_LAWSUIT,
  STAGE_TRIAL,
  STAGE_EVALUATE_JUDGEMENT,
  STAGE_LAWSUIT_COMPLETED,
  STAGE_COMPLETED,
} from "./StagesCase";

export const stageMetaDataGeneralCivilLaw: StageMetaData = {
  [stage.STAGE_CREATED]: stageMetaDataCase[stage.STAGE_CREATED],
  [stage.STAGE_DATA_COMPLETED]: stageMetaDataCase[stage.STAGE_DATA_COMPLETED],
  [stage.STAGE_WAITING_FOR_FEEDBACK]: stageMetaDataCase[stage.STAGE_WAITING_FOR_FEEDBACK],
  [stage.STAGE_DATA_COMPLETED_LAWFIRM]: stageMetaDataCase[stage.STAGE_DATA_COMPLETED_LAWFIRM],
  [stage.STAGE_CHECKED]: stageMetaDataCase[stage.STAGE_CHECKED],
  [stage.STAGE_IN_PROGRESS]: stageMetaDataCase[stage.STAGE_IN_PROGRESS],
  [stage.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT]: stageMetaDataCase[stage.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT],
  [stage.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED]: stageMetaDataCase[stage.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED],
  [stage.STAGE_ACTION_REQUIRED]: stageMetaDataCase[stage.STAGE_ACTION_REQUIRED],
  [stage.STAGE_PREPARE_LAWSUIT]: stageMetaDataCase[stage.STAGE_PREPARE_LAWSUIT],
  [stage.STAGE_LAWSUIT]: stageMetaDataCase[stage.STAGE_LAWSUIT],
  [stage.STAGE_TRIAL]: stageMetaDataCase[stage.STAGE_TRIAL],
  [stage.STAGE_EVALUATE_JUDGEMENT]: stageMetaDataCase[stage.STAGE_EVALUATE_JUDGEMENT],
  [stage.STAGE_LAWSUIT_COMPLETED]: stageMetaDataCase[stage.STAGE_LAWSUIT_COMPLETED],
  [stage.STAGE_COMPLETED]: stageMetaDataCase[stage.STAGE_COMPLETED],
};
